/* @flow weak */
import Button from 'components/Button.jsx';
import cx from 'classnames';
import Hovercard from 'components/Hovercard.jsx';
import HovercardBody from 'components/HovercardBody.jsx';
import React from 'react';
import SettingsStore from 'stores/SettingsStore';

import './styles/LanguageHoverCard.scss';

class LanguageHoverCard extends React.Component {
  static propTypes = {
    onLanguagePicked: React.PropTypes.func.isRequired,
    eventContextName: React.PropTypes.string,
    additionalLanguages: React.PropTypes.object,
  };

  static defaultProps = {
    additionalLanguages: {},
  };

  render() {
    const languageNames = Object.assign(
      {},
      SettingsStore.getLanguages().secondary,
      this.props.additionalLanguages
    );

    const sortedLanguages = Object.entries(languageNames)
      .map(([code, name]) => ({ code, name }))
      .sort((a, b) => +(a.name > b.name) || +(a.name === b.name) - 1);

    const items = sortedLanguages.map(language => (
      <Button
        {...this.props}
        key={language.code}
        level="text"
        className="LanguageHoverCard-language"
        eventScreenName="language_dialog"
        eventElementName="translate_button"
        eventProperties={{
          language_code: language.code,
        }}
        onClick={() => {
          this.props.onRequestHide();
          this.props.onLanguagePicked(language.code);
        }
        }>
        {language.name}
      </Button>
    ));

    return (
      <Hovercard
        {...this.props}
        className={cx('LanguageHoverCard', this.props.className)}>
        <HovercardBody className="LanguageHoverCard-body">
          {items}
        </HovercardBody>
      </Hovercard>
    );
  }
}

export default LanguageHoverCard;



// WEBPACK FOOTER //
// ./src/chat/components/LanguageHoverCard.jsx